import {Component, Inject, OnInit, ViewChild,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService,} from '../../_services/index';

import {User} from '../../_models/index';

import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {MatStepper} from '@angular/material/stepper';


import {LoginHelper, Recurring, Role} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import * as moment from 'moment';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {TrainingService} from "../../_services/training.service";
import {SelectControlItemComponent} from "../selectControlItem/select-control-item.component";
import {saveAs as importedSaveAs} from "file-saver";
import {BehaviorSubject, forkJoin} from "rxjs";
import {TrainingInviteComponent} from "../trainingInvite/training-invite.component";
import {TrainingUserAnswersComponent} from "../trainingUserAnswers/trainingUserAnswers.component";

const defaultDialogConfig = new MatDialogConfig();

@Component({
    standalone: false,
  selector: "training-edit-component",
  templateUrl: 'training-edit.component.html',
  styleUrls: ['./training-edit.component.scss'],
})

export class TrainingEditComponent implements OnInit {
  api: string = window.location.origin;
  tenantName: string = LoginHelper.getTenantName();
  userToken: string = LoginHelper.getFileToken();
  quizForm: FormGroup;
  inviteText = '';
  recurringList = [];
  recurring = {};
  activeTab = 0;
  quiz = {
    id: 0,
    quiz: '',
    quizData: {
      name: '',
      steps: [
        {items: []}
      ]
    },
    trainingUsers: []
  };
  users: any[] = [];
  assignedUsers: any[] = [];
  public selectDialogRef: MatDialogRef<SelectControlItemComponent>;
  cols : any[] = [
    {'field': 'category', 'header': 'Category'},
    {'field': 'complianceAreaControlId', 'header': 'Control ID'},
    {'field': 'description', 'header': 'Description'}
  ];
  fromDate = '';
  toDate = '';
  trainingId: number;
  @ViewChild('stepper') stepper: MatStepper;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public _formBuilder: FormBuilder,
    public trainingService: TrainingService) {
    for (let i = 0; i <= Recurring.Yearly; i++) {
      this.recurringList.push({label: Recurring[i].toString(), value: i});
      this.recurring[i] = Recurring[i].toString();
    }
  }

  ngOnInit() {
    this.route.params.subscribe(p => {
      this.trainingId = p['trainingId'];
      this.loadData();
    })
    this.quizForm = this._formBuilder.group({
      name: ['', Validators.required],
    });
  }

  loadData() {
    forkJoin(this.userService.getAllShort(),
      this.trainingId ? this.trainingService.getTraining(this.trainingId) : new BehaviorSubject(null),
      this.trainingService.getTrainingResults())
      .subscribe(r => {
        if (r[1]) {
          this.quiz = r[1];
        }
        this.users = r[0].filter(u => u.role & (Role.Survey | Role.Training));
        this.assignedUsers = (this.quiz.trainingUsers || []).map(u => r[0].find(a => a.userId == u)).filter(u => u);
        const assigned = (this.quiz.trainingUsers || []).map(u => ({
          assignmentUser: u,
          usr: r[0].find(a => a.userId == u.userId)
        })).filter(u => u.usr);

        r[2].filter(a => a.trainingId == this.trainingId).forEach(a => {
          if (!assigned.find(s => s.usr.userId == a.userId)){
            assigned.push({assignmentUser: null, usr: r[0].find(u => a.userId == u.userId)});
          }
        });

        this.users = assigned.map(u => {
          const userAnswers = r[2].filter(a => a.trainingId == this.trainingId && a.userId == u.usr.userId).sort((a, b) => a.date - b.date);
          return {
            ...u.usr, ...u.assignmentUser,
            answers: userAnswers,
            nextDate: u.assignmentUser ? u.assignmentUser.frequency == Recurring.None ? null :
              u.assignmentUser.frequency == Recurring.Daily ? moment(userAnswers.length > 0 ? userAnswers[0].date : new Date()).add(1, 'day').toDate() :
                u.assignmentUser.frequency == Recurring.Weekly ? moment(userAnswers.length > 0 ? userAnswers[0].date : new Date()).add(1, 'week').toDate() :
                  u.assignmentUser.frequency == Recurring.Monthly ? moment(userAnswers.length > 0 ? userAnswers[0].date : new Date()).add(1, 'month').toDate() :
                    u.assignmentUser.frequency == Recurring.Quarterly ? moment(userAnswers.length > 0 ? userAnswers[0].date : new Date()).add(1, 'quarter').toDate() :
                      moment(userAnswers.length > 0 ? userAnswers[0].date : new Date()).add(1, 'year').toDate() : null
          };
        });
      });
  }

  send() {
    if (this.quizForm.valid) {
      this.quiz.quiz = JSON.stringify(this.quiz.quizData);
      this.trainingService.saveTraining(this.quiz).subscribe((i) => {
        this.quiz.id = i;
        this.alertService.success("Successfully saved");
      });
    }
  }

  invite() {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
      data: {
        trainingId: this.trainingId
      }
    };

    const ref = this.dialog.open(TrainingInviteComponent, config);

    ref.afterClosed().subscribe((data: any) => {
      this.loadData();
    });
  }

  sendInvite() {
    if (this.assignedUsers.length == 0)
    {
      this.alertService.success("Please, select users");
      return;
    }
    this.trainingService.inviteToTraining({
      ...this.quiz,
      trainingUsers: this.assignedUsers.map(u => ({userId: u.userId, trainingId: this.trainingId}))
    }, this.inviteText).subscribe(() => {
      this.assignedUsers = [];
      this.alertService.success("Invitations successfully sent");
    });
  }

  addStep() {
    this.quiz.quizData.steps.push({items: []})
  }

  removeStep(i) {
    this.stepper.selectedIndex = 0;
    setTimeout(() => this.quiz.quizData.steps.splice(i, 1), 500);
  }

  moveUp(list, i) {
    const s = list[i];
    list[i] = list[i - 1];
    list[i - 1] = s;
  }

  moveDown(list, i) {
    const s = list[i];
    list[i] = list[i + 1];
    list[i + 1] = s;
  }

  addVideo(list) {
    list.push({type: 'video', src: ''});
  }

  addQuestion(list) {
    list.push({type: 'question', name: '', answers: [], multiple: false, correctValue: 0});
  }

  addAnswer(list) {
    list.push({name: '', correct: false});
  }

  removeTraining() {
    this.trainingService.deleteTraining(this.trainingId).subscribe(t => {
      this.router.navigate(['training']);
    });
  }

  public uploadImage(list, event) {
    let files = event.target.files;
    if (files.length > 0) {

      this.trainingService.uploadFile(files[0])
        .subscribe(data => {
          list.push({type: 'image', src: data.fileName});
        });
    }
  }

  create() {
    this.quiz = {id: 0, quiz: "", quizData: {name: "", steps: [{items: []}]}, trainingUsers: []};
  }

  public getFullName(user: User): string {
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }

  open(item) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '98%',
      height: '90vh',
      data: {
        quiz: this.quiz,
        answers: item,
        trainingId: this.trainingId,
      }
    };

    const dialogRef = this.dialog.open(TrainingUserAnswersComponent, config);
  }

  updateFrequency(item, frequency) {
    this.quiz.trainingUsers.find(u => u.userId == item.userId).frequency = frequency;
    this.send();
  }

  exportAnswers() {
    if (!this.assignedUsers || this.assignedUsers.length == 0)
    {
      this.alertService.error('Please, select users to export');
      return;
    }
    this.trainingService.exportAnswers(this.trainingId, null, this.assignedUsers.map(b => b.userId), this.fromDate, this.toDate).subscribe(blob => {
        importedSaveAs(new Blob([blob], {type: 'application/ms-excel'}), 'Answers.xlsx');
      },
      error => {
        const errorMessage = 'An error occurred while downloading results.';
        this.alertService.error(errorMessage);
      });

  }

  protected readonly window = window;
  protected readonly encodeURIComponent = encodeURIComponent;
}
